'use client'
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// #style-inject:#style-inject
function styleInject(css, { insertAt } = {}) {
  if (!css || typeof document === "undefined")
    return;
  const head = document.head || document.getElementsByTagName("head")[0];
  const style = document.createElement("style");
  style.type = "text/css";
  if (insertAt === "top") {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

// src/styles/index.css
styleInject(':root {\n  --novel-black: rgb(0 0 0);\n  --novel-white: rgb(255 255 255);\n  --novel-stone-50: rgb(250 250 249);\n  --novel-stone-100: rgb(245 245 244);\n  --novel-stone-200: rgb(231 229 228);\n  --novel-stone-300: rgb(214 211 209);\n  --novel-stone-400: rgb(168 162 158);\n  --novel-stone-500: rgb(120 113 108);\n  --novel-stone-600: rgb(87 83 78);\n  --novel-stone-700: rgb(68 64 60);\n  --novel-stone-800: rgb(41 37 36);\n  --novel-stone-900: rgb(28 25 23);\n  --novel-highlight-default: #ffffff;\n  --novel-highlight-purple: #f6f3f8;\n  --novel-highlight-red: #fdebeb;\n  --novel-highlight-yellow: #fbf4a2;\n  --novel-highlight-blue: #c1ecf9;\n  --novel-highlight-green: #acf79f;\n  --novel-highlight-orange: #faebdd;\n  --novel-highlight-pink: #faf1f5;\n  --novel-highlight-gray: #f1f1ef;\n  --font-title: "Cal Sans", sans-serif;\n}\n.dark-theme {\n  --novel-black: rgb(255 255 255);\n  --novel-white: rgb(25 25 25);\n  --novel-stone-50: rgb(35 35 34);\n  --novel-stone-100: rgb(41 37 36);\n  --novel-stone-200: rgb(66 69 71);\n  --novel-stone-300: rgb(112 118 123);\n  --novel-stone-400: rgb(160 167 173);\n  --novel-stone-500: rgb(193 199 204);\n  --novel-stone-600: rgb(212 217 221);\n  --novel-stone-700: rgb(229 232 235);\n  --novel-stone-800: rgb(232 234 235);\n  --novel-stone-900: rgb(240, 240, 241);\n  --novel-highlight-default: #000000;\n  --novel-highlight-purple: #3f2c4b;\n  --novel-highlight-red: #5c1a1a;\n  --novel-highlight-yellow: #5c4b1a;\n  --novel-highlight-blue: #1a3d5c;\n  --novel-highlight-green: #1a5c20;\n  --novel-highlight-orange: #5c3a1a;\n  --novel-highlight-pink: #5c1a3a;\n  --novel-highlight-gray: #3a3a3a;\n}\n@font-face {\n  font-family: "Cal Sans";\n  src: local("Cal Sans"), url(CalSans-SemiBold.otf) format("otf");\n}\n');

// src/styles/tailwind.css
styleInject('*,\n::before,\n::after {\n  box-sizing: border-box;\n  border-width: 0;\n  border-style: solid;\n  border-color: #e5e7eb;\n}\n::before,\n::after {\n  --tw-content: "";\n}\nhtml,\n:host {\n  line-height: 1.5;\n  -webkit-text-size-adjust: 100%;\n  -moz-tab-size: 4;\n  -o-tab-size: 4;\n  tab-size: 4;\n  font-family:\n    ui-sans-serif,\n    system-ui,\n    sans-serif,\n    "Apple Color Emoji",\n    "Segoe UI Emoji",\n    "Segoe UI Symbol",\n    "Noto Color Emoji";\n  font-feature-settings: normal;\n  font-variation-settings: normal;\n  -webkit-tap-highlight-color: transparent;\n}\nbody {\n  margin: 0;\n  line-height: inherit;\n}\nhr {\n  height: 0;\n  color: inherit;\n  border-top-width: 1px;\n}\nabbr:where([title]) {\n  -webkit-text-decoration: underline dotted;\n  text-decoration: underline dotted;\n}\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  font-size: inherit;\n  font-weight: inherit;\n}\na {\n  color: inherit;\n  text-decoration: inherit;\n}\nb,\nstrong {\n  font-weight: bolder;\n}\ncode,\nkbd,\nsamp,\npre {\n  font-family:\n    ui-monospace,\n    SFMono-Regular,\n    Menlo,\n    Monaco,\n    Consolas,\n    "Liberation Mono",\n    "Courier New",\n    monospace;\n  font-feature-settings: normal;\n  font-variation-settings: normal;\n  font-size: 1em;\n}\nsmall {\n  font-size: 80%;\n}\nsub,\nsup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}\nsub {\n  bottom: -0.25em;\n}\nsup {\n  top: -0.5em;\n}\ntable {\n  text-indent: 0;\n  border-color: inherit;\n  border-collapse: collapse;\n}\nbutton,\ninput,\noptgroup,\nselect,\ntextarea {\n  font-family: inherit;\n  font-feature-settings: inherit;\n  font-variation-settings: inherit;\n  font-size: 100%;\n  font-weight: inherit;\n  line-height: inherit;\n  letter-spacing: inherit;\n  color: inherit;\n  margin: 0;\n  padding: 0;\n}\nbutton,\nselect {\n  text-transform: none;\n}\nbutton,\ninput:where([type=button]),\ninput:where([type=reset]),\ninput:where([type=submit]) {\n  -webkit-appearance: button;\n  background-color: transparent;\n  background-image: none;\n}\n:-moz-focusring {\n  outline: auto;\n}\n:-moz-ui-invalid {\n  box-shadow: none;\n}\nprogress {\n  vertical-align: baseline;\n}\n::-webkit-inner-spin-button,\n::-webkit-outer-spin-button {\n  height: auto;\n}\n[type=search] {\n  -webkit-appearance: textfield;\n  outline-offset: -2px;\n}\n::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n::-webkit-file-upload-button {\n  -webkit-appearance: button;\n  font: inherit;\n}\nsummary {\n  display: list-item;\n}\nblockquote,\ndl,\ndd,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\nhr,\nfigure,\np,\npre {\n  margin: 0;\n}\nfieldset {\n  margin: 0;\n  padding: 0;\n}\nlegend {\n  padding: 0;\n}\nol,\nul,\nmenu {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\ndialog {\n  padding: 0;\n}\ntextarea {\n  resize: vertical;\n}\ninput::-moz-placeholder,\ntextarea::-moz-placeholder {\n  opacity: 1;\n  color: #9ca3af;\n}\ninput::placeholder,\ntextarea::placeholder {\n  opacity: 1;\n  color: #9ca3af;\n}\nbutton,\n[role=button] {\n  cursor: pointer;\n}\n:disabled {\n  cursor: default;\n}\nimg,\nsvg,\nvideo,\ncanvas,\naudio,\niframe,\nembed,\nobject {\n  display: block;\n  vertical-align: middle;\n}\nimg,\nvideo {\n  max-width: 100%;\n  height: auto;\n}\n[hidden] {\n  display: none;\n}\n*,\n::before,\n::after {\n  --tw-border-spacing-x: 0;\n  --tw-border-spacing-y: 0;\n  --tw-translate-x: 0;\n  --tw-translate-y: 0;\n  --tw-rotate: 0;\n  --tw-skew-x: 0;\n  --tw-skew-y: 0;\n  --tw-scale-x: 1;\n  --tw-scale-y: 1;\n  --tw-pan-x: ;\n  --tw-pan-y: ;\n  --tw-pinch-zoom: ;\n  --tw-scroll-snap-strictness: proximity;\n  --tw-gradient-from-position: ;\n  --tw-gradient-via-position: ;\n  --tw-gradient-to-position: ;\n  --tw-ordinal: ;\n  --tw-slashed-zero: ;\n  --tw-numeric-figure: ;\n  --tw-numeric-spacing: ;\n  --tw-numeric-fraction: ;\n  --tw-ring-inset: ;\n  --tw-ring-offset-width: 0px;\n  --tw-ring-offset-color: #fff;\n  --tw-ring-color: rgb(59 130 246 / 0.5);\n  --tw-ring-offset-shadow: 0 0 #0000;\n  --tw-ring-shadow: 0 0 #0000;\n  --tw-shadow: 0 0 #0000;\n  --tw-shadow-colored: 0 0 #0000;\n  --tw-blur: ;\n  --tw-brightness: ;\n  --tw-contrast: ;\n  --tw-grayscale: ;\n  --tw-hue-rotate: ;\n  --tw-invert: ;\n  --tw-saturate: ;\n  --tw-sepia: ;\n  --tw-drop-shadow: ;\n  --tw-backdrop-blur: ;\n  --tw-backdrop-brightness: ;\n  --tw-backdrop-contrast: ;\n  --tw-backdrop-grayscale: ;\n  --tw-backdrop-hue-rotate: ;\n  --tw-backdrop-invert: ;\n  --tw-backdrop-opacity: ;\n  --tw-backdrop-saturate: ;\n  --tw-backdrop-sepia: ;\n  --tw-contain-size: ;\n  --tw-contain-layout: ;\n  --tw-contain-paint: ;\n  --tw-contain-style: ;\n}\n::backdrop {\n  --tw-border-spacing-x: 0;\n  --tw-border-spacing-y: 0;\n  --tw-translate-x: 0;\n  --tw-translate-y: 0;\n  --tw-rotate: 0;\n  --tw-skew-x: 0;\n  --tw-skew-y: 0;\n  --tw-scale-x: 1;\n  --tw-scale-y: 1;\n  --tw-pan-x: ;\n  --tw-pan-y: ;\n  --tw-pinch-zoom: ;\n  --tw-scroll-snap-strictness: proximity;\n  --tw-gradient-from-position: ;\n  --tw-gradient-via-position: ;\n  --tw-gradient-to-position: ;\n  --tw-ordinal: ;\n  --tw-slashed-zero: ;\n  --tw-numeric-figure: ;\n  --tw-numeric-spacing: ;\n  --tw-numeric-fraction: ;\n  --tw-ring-inset: ;\n  --tw-ring-offset-width: 0px;\n  --tw-ring-offset-color: #fff;\n  --tw-ring-color: rgb(59 130 246 / 0.5);\n  --tw-ring-offset-shadow: 0 0 #0000;\n  --tw-ring-shadow: 0 0 #0000;\n  --tw-shadow: 0 0 #0000;\n  --tw-shadow-colored: 0 0 #0000;\n  --tw-blur: ;\n  --tw-brightness: ;\n  --tw-contrast: ;\n  --tw-grayscale: ;\n  --tw-hue-rotate: ;\n  --tw-invert: ;\n  --tw-saturate: ;\n  --tw-sepia: ;\n  --tw-drop-shadow: ;\n  --tw-backdrop-blur: ;\n  --tw-backdrop-brightness: ;\n  --tw-backdrop-contrast: ;\n  --tw-backdrop-grayscale: ;\n  --tw-backdrop-hue-rotate: ;\n  --tw-backdrop-invert: ;\n  --tw-backdrop-opacity: ;\n  --tw-backdrop-saturate: ;\n  --tw-backdrop-sepia: ;\n  --tw-contain-size: ;\n  --tw-contain-layout: ;\n  --tw-contain-paint: ;\n  --tw-contain-style: ;\n}\n.novel-prose-lg {\n  font-size: 1.125rem;\n  line-height: 1.7777778;\n}\n.novel-prose-lg :where(p):not(:where([class~=novel-not-prose], [class~=novel-not-prose] *)) {\n  margin-top: 1.3333333em;\n  margin-bottom: 1.3333333em;\n}\n.novel-prose-lg :where([class~=lead]):not(:where([class~=novel-not-prose], [class~=novel-not-prose] *)) {\n  font-size: 1.2222222em;\n  line-height: 1.4545455;\n  margin-top: 1.0909091em;\n  margin-bottom: 1.0909091em;\n}\n.novel-prose-lg :where(blockquote):not(:where([class~=novel-not-prose], [class~=novel-not-prose] *)) {\n  margin-top: 1.6666667em;\n  margin-bottom: 1.6666667em;\n  padding-inline-start: 1em;\n}\n.novel-prose-lg :where(h1):not(:where([class~=novel-not-prose], [class~=novel-not-prose] *)) {\n  font-size: 2.6666667em;\n  margin-top: 0;\n  margin-bottom: 0.8333333em;\n  line-height: 1;\n}\n.novel-prose-lg :where(h2):not(:where([class~=novel-not-prose], [class~=novel-not-prose] *)) {\n  font-size: 1.6666667em;\n  margin-top: 1.8666667em;\n  margin-bottom: 1.0666667em;\n  line-height: 1.3333333;\n}\n.novel-prose-lg :where(h3):not(:where([class~=novel-not-prose], [class~=novel-not-prose] *)) {\n  font-size: 1.3333333em;\n  margin-top: 1.6666667em;\n  margin-bottom: 0.6666667em;\n  line-height: 1.5;\n}\n.novel-prose-lg :where(h4):not(:where([class~=novel-not-prose], [class~=novel-not-prose] *)) {\n  margin-top: 1.7777778em;\n  margin-bottom: 0.4444444em;\n  line-height: 1.5555556;\n}\n.novel-prose-lg :where(img):not(:where([class~=novel-not-prose], [class~=novel-not-prose] *)) {\n  margin-top: 1.7777778em;\n  margin-bottom: 1.7777778em;\n}\n.novel-prose-lg :where(picture):not(:where([class~=novel-not-prose], [class~=novel-not-prose] *)) {\n  margin-top: 1.7777778em;\n  margin-bottom: 1.7777778em;\n}\n.novel-prose-lg :where(picture > img):not(:where([class~=novel-not-prose], [class~=novel-not-prose] *)) {\n  margin-top: 0;\n  margin-bottom: 0;\n}\n.novel-prose-lg :where(video):not(:where([class~=novel-not-prose], [class~=novel-not-prose] *)) {\n  margin-top: 1.7777778em;\n  margin-bottom: 1.7777778em;\n}\n.novel-prose-lg :where(kbd):not(:where([class~=novel-not-prose], [class~=novel-not-prose] *)) {\n  font-size: 0.8888889em;\n  border-radius: 0.3125rem;\n  padding-top: 0.2222222em;\n  padding-inline-end: 0.4444444em;\n  padding-bottom: 0.2222222em;\n  padding-inline-start: 0.4444444em;\n}\n.novel-prose-lg :where(code):not(:where([class~=novel-not-prose], [class~=novel-not-prose] *)) {\n  font-size: 0.8888889em;\n}\n.novel-prose-lg :where(h2 code):not(:where([class~=novel-not-prose], [class~=novel-not-prose] *)) {\n  font-size: 0.8666667em;\n}\n.novel-prose-lg :where(h3 code):not(:where([class~=novel-not-prose], [class~=novel-not-prose] *)) {\n  font-size: 0.875em;\n}\n.novel-prose-lg :where(pre):not(:where([class~=novel-not-prose], [class~=novel-not-prose] *)) {\n  font-size: 0.8888889em;\n  line-height: 1.75;\n  margin-top: 2em;\n  margin-bottom: 2em;\n  border-radius: 0.375rem;\n  padding-top: 1em;\n  padding-inline-end: 1.5em;\n  padding-bottom: 1em;\n  padding-inline-start: 1.5em;\n}\n.novel-prose-lg :where(ol):not(:where([class~=novel-not-prose], [class~=novel-not-prose] *)) {\n  margin-top: 1.3333333em;\n  margin-bottom: 1.3333333em;\n  padding-inline-start: 1.5555556em;\n}\n.novel-prose-lg :where(ul):not(:where([class~=novel-not-prose], [class~=novel-not-prose] *)) {\n  margin-top: 1.3333333em;\n  margin-bottom: 1.3333333em;\n  padding-inline-start: 1.5555556em;\n}\n.novel-prose-lg :where(li):not(:where([class~=novel-not-prose], [class~=novel-not-prose] *)) {\n  margin-top: 0.6666667em;\n  margin-bottom: 0.6666667em;\n}\n.novel-prose-lg :where(ol > li):not(:where([class~=novel-not-prose], [class~=novel-not-prose] *)) {\n  padding-inline-start: 0.4444444em;\n}\n.novel-prose-lg :where(ul > li):not(:where([class~=novel-not-prose], [class~=novel-not-prose] *)) {\n  padding-inline-start: 0.4444444em;\n}\n.novel-prose-lg :where(.novel-prose-lg > ul > li p):not(:where([class~=novel-not-prose], [class~=novel-not-prose] *)) {\n  margin-top: 0.8888889em;\n  margin-bottom: 0.8888889em;\n}\n.novel-prose-lg :where(.novel-prose-lg > ul > li > p:first-child):not(:where([class~=novel-not-prose], [class~=novel-not-prose] *)) {\n  margin-top: 1.3333333em;\n}\n.novel-prose-lg :where(.novel-prose-lg > ul > li > p:last-child):not(:where([class~=novel-not-prose], [class~=novel-not-prose] *)) {\n  margin-bottom: 1.3333333em;\n}\n.novel-prose-lg :where(.novel-prose-lg > ol > li > p:first-child):not(:where([class~=novel-not-prose], [class~=novel-not-prose] *)) {\n  margin-top: 1.3333333em;\n}\n.novel-prose-lg :where(.novel-prose-lg > ol > li > p:last-child):not(:where([class~=novel-not-prose], [class~=novel-not-prose] *)) {\n  margin-bottom: 1.3333333em;\n}\n.novel-prose-lg :where(ul ul, ul ol, ol ul, ol ol):not(:where([class~=novel-not-prose], [class~=novel-not-prose] *)) {\n  margin-top: 0.8888889em;\n  margin-bottom: 0.8888889em;\n}\n.novel-prose-lg :where(dl):not(:where([class~=novel-not-prose], [class~=novel-not-prose] *)) {\n  margin-top: 1.3333333em;\n  margin-bottom: 1.3333333em;\n}\n.novel-prose-lg :where(dt):not(:where([class~=novel-not-prose], [class~=novel-not-prose] *)) {\n  margin-top: 1.3333333em;\n}\n.novel-prose-lg :where(dd):not(:where([class~=novel-not-prose], [class~=novel-not-prose] *)) {\n  margin-top: 0.6666667em;\n  padding-inline-start: 1.5555556em;\n}\n.novel-prose-lg :where(hr):not(:where([class~=novel-not-prose], [class~=novel-not-prose] *)) {\n  margin-top: 3.1111111em;\n  margin-bottom: 3.1111111em;\n}\n.novel-prose-lg :where(hr + *):not(:where([class~=novel-not-prose], [class~=novel-not-prose] *)) {\n  margin-top: 0;\n}\n.novel-prose-lg :where(h2 + *):not(:where([class~=novel-not-prose], [class~=novel-not-prose] *)) {\n  margin-top: 0;\n}\n.novel-prose-lg :where(h3 + *):not(:where([class~=novel-not-prose], [class~=novel-not-prose] *)) {\n  margin-top: 0;\n}\n.novel-prose-lg :where(h4 + *):not(:where([class~=novel-not-prose], [class~=novel-not-prose] *)) {\n  margin-top: 0;\n}\n.novel-prose-lg :where(table):not(:where([class~=novel-not-prose], [class~=novel-not-prose] *)) {\n  font-size: 0.8888889em;\n  line-height: 1.5;\n}\n.novel-prose-lg :where(thead th):not(:where([class~=novel-not-prose], [class~=novel-not-prose] *)) {\n  padding-inline-end: 0.75em;\n  padding-bottom: 0.75em;\n  padding-inline-start: 0.75em;\n}\n.novel-prose-lg :where(thead th:first-child):not(:where([class~=novel-not-prose], [class~=novel-not-prose] *)) {\n  padding-inline-start: 0;\n}\n.novel-prose-lg :where(thead th:last-child):not(:where([class~=novel-not-prose], [class~=novel-not-prose] *)) {\n  padding-inline-end: 0;\n}\n.novel-prose-lg :where(tbody td, tfoot td):not(:where([class~=novel-not-prose], [class~=novel-not-prose] *)) {\n  padding-top: 0.75em;\n  padding-inline-end: 0.75em;\n  padding-bottom: 0.75em;\n  padding-inline-start: 0.75em;\n}\n.novel-prose-lg :where(tbody td:first-child, tfoot td:first-child):not(:where([class~=novel-not-prose], [class~=novel-not-prose] *)) {\n  padding-inline-start: 0;\n}\n.novel-prose-lg :where(tbody td:last-child, tfoot td:last-child):not(:where([class~=novel-not-prose], [class~=novel-not-prose] *)) {\n  padding-inline-end: 0;\n}\n.novel-prose-lg :where(figure):not(:where([class~=novel-not-prose], [class~=novel-not-prose] *)) {\n  margin-top: 1.7777778em;\n  margin-bottom: 1.7777778em;\n}\n.novel-prose-lg :where(figure > *):not(:where([class~=novel-not-prose], [class~=novel-not-prose] *)) {\n  margin-top: 0;\n  margin-bottom: 0;\n}\n.novel-prose-lg :where(figcaption):not(:where([class~=novel-not-prose], [class~=novel-not-prose] *)) {\n  font-size: 0.8888889em;\n  line-height: 1.5;\n  margin-top: 1em;\n}\n.novel-prose-lg :where(.novel-prose-lg > :first-child):not(:where([class~=novel-not-prose], [class~=novel-not-prose] *)) {\n  margin-top: 0;\n}\n.novel-prose-lg :where(.novel-prose-lg > :last-child):not(:where([class~=novel-not-prose], [class~=novel-not-prose] *)) {\n  margin-bottom: 0;\n}\n.novel-prose-stone {\n  --tw-prose-body: #44403c;\n  --tw-prose-headings: #1c1917;\n  --tw-prose-lead: #57534e;\n  --tw-prose-links: #1c1917;\n  --tw-prose-bold: #1c1917;\n  --tw-prose-counters: #78716c;\n  --tw-prose-bullets: #d6d3d1;\n  --tw-prose-hr: #e7e5e4;\n  --tw-prose-quotes: #1c1917;\n  --tw-prose-quote-borders: #e7e5e4;\n  --tw-prose-captions: #78716c;\n  --tw-prose-kbd: #1c1917;\n  --tw-prose-kbd-shadows: 28 25 23;\n  --tw-prose-code: #1c1917;\n  --tw-prose-pre-code: #e7e5e4;\n  --tw-prose-pre-bg: #292524;\n  --tw-prose-th-borders: #d6d3d1;\n  --tw-prose-td-borders: #e7e5e4;\n  --tw-prose-invert-body: #d6d3d1;\n  --tw-prose-invert-headings: #fff;\n  --tw-prose-invert-lead: #a8a29e;\n  --tw-prose-invert-links: #fff;\n  --tw-prose-invert-bold: #fff;\n  --tw-prose-invert-counters: #a8a29e;\n  --tw-prose-invert-bullets: #57534e;\n  --tw-prose-invert-hr: #44403c;\n  --tw-prose-invert-quotes: #f5f5f4;\n  --tw-prose-invert-quote-borders: #44403c;\n  --tw-prose-invert-captions: #a8a29e;\n  --tw-prose-invert-kbd: #fff;\n  --tw-prose-invert-kbd-shadows: 255 255 255;\n  --tw-prose-invert-code: #fff;\n  --tw-prose-invert-pre-code: #d6d3d1;\n  --tw-prose-invert-pre-bg: rgb(0 0 0 / 50%);\n  --tw-prose-invert-th-borders: #57534e;\n  --tw-prose-invert-td-borders: #44403c;\n}\n.novel-fixed {\n  position: fixed;\n}\n.novel-relative {\n  position: relative;\n}\n.novel-top-full {\n  top: 100%;\n}\n.novel-z-50 {\n  z-index: 50;\n}\n.novel-z-\\[99999\\] {\n  z-index: 99999;\n}\n.novel-my-1 {\n  margin-top: 0.25rem;\n  margin-bottom: 0.25rem;\n}\n.novel-my-4 {\n  margin-top: 1rem;\n  margin-bottom: 1rem;\n}\n.novel--mb-2 {\n  margin-bottom: -0.5rem;\n}\n.novel--mt-2 {\n  margin-top: -0.5rem;\n}\n.novel-mb-1 {\n  margin-bottom: 0.25rem;\n}\n.novel-mb-6 {\n  margin-bottom: 1.5rem;\n}\n.novel-mt-1 {\n  margin-top: 0.25rem;\n}\n.novel-mt-2 {\n  margin-top: 0.5rem;\n}\n.novel-mt-4 {\n  margin-top: 1rem;\n}\n.novel-flex {\n  display: flex;\n}\n.novel-h-10 {\n  height: 2.5rem;\n}\n.novel-h-3 {\n  height: 0.75rem;\n}\n.novel-h-4 {\n  height: 1rem;\n}\n.novel-h-auto {\n  height: auto;\n}\n.novel-h-full {\n  height: 100%;\n}\n.novel-max-h-80 {\n  max-height: 20rem;\n}\n.novel-max-h-\\[330px\\] {\n  max-height: 330px;\n}\n.novel-w-10 {\n  width: 2.5rem;\n}\n.novel-w-3 {\n  width: 0.75rem;\n}\n.novel-w-4 {\n  width: 1rem;\n}\n.novel-w-48 {\n  width: 12rem;\n}\n.novel-w-60 {\n  width: 15rem;\n}\n.novel-w-7 {\n  width: 1.75rem;\n}\n.novel-w-72 {\n  width: 18rem;\n}\n.novel-w-fit {\n  width: -moz-fit-content;\n  width: fit-content;\n}\n.novel-w-full {\n  width: 100%;\n}\n.novel-max-w-full {\n  max-width: 100%;\n}\n.novel-max-w-screen-lg {\n  max-width: 1024px;\n}\n.novel-flex-1 {\n  flex: 1 1 0%;\n}\n@keyframes novel-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n.novel-animate-spin {\n  animation: novel-spin 1s linear infinite;\n}\n.novel-cursor-pointer {\n  cursor: pointer;\n}\n.novel-list-outside {\n  list-style-position: outside;\n}\n.novel-list-decimal {\n  list-style-type: decimal;\n}\n.novel-list-disc {\n  list-style-type: disc;\n}\n.novel-flex-col {\n  flex-direction: column;\n}\n.novel-items-start {\n  align-items: flex-start;\n}\n.novel-items-center {\n  align-items: center;\n}\n.novel-justify-center {\n  justify-content: center;\n}\n.novel-justify-between {\n  justify-content: space-between;\n}\n.novel-gap-1 {\n  gap: 0.25rem;\n}\n.novel-space-x-2 > :not([hidden]) ~ :not([hidden]) {\n  --tw-space-x-reverse: 0;\n  margin-right: calc(0.5rem * var(--tw-space-x-reverse));\n  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));\n}\n.novel-divide-x > :not([hidden]) ~ :not([hidden]) {\n  --tw-divide-x-reverse: 0;\n  border-right-width: calc(1px * var(--tw-divide-x-reverse));\n  border-left-width: calc(1px * calc(1 - var(--tw-divide-x-reverse)));\n}\n.novel-divide-stone-200 > :not([hidden]) ~ :not([hidden]) {\n  border-color: var(--novel-stone-200);\n}\n.novel-overflow-hidden {\n  overflow: hidden;\n}\n.novel-overflow-y-auto {\n  overflow-y: auto;\n}\n.novel-whitespace-nowrap {\n  white-space: nowrap;\n}\n.novel-rounded {\n  border-radius: 0.25rem;\n}\n.novel-rounded-lg {\n  border-radius: 0.5rem;\n}\n.novel-rounded-md {\n  border-radius: 0.375rem;\n}\n.novel-rounded-sm {\n  border-radius: 0.125rem;\n}\n.novel-border {\n  border-width: 1px;\n}\n.novel-border-l-4 {\n  border-left-width: 4px;\n}\n.novel-border-t {\n  border-top-width: 1px;\n}\n.novel-border-stone-200 {\n  border-color: var(--novel-stone-200);\n}\n.novel-border-stone-300 {\n  border-color: var(--novel-stone-300);\n}\n.novel-border-stone-700 {\n  border-color: var(--novel-stone-700);\n}\n.novel-bg-stone-100 {\n  background-color: var(--novel-stone-100);\n}\n.novel-bg-stone-200 {\n  background-color: var(--novel-stone-200);\n}\n.novel-bg-white {\n  background-color: var(--novel-white);\n}\n.novel-fill-stone-600 {\n  fill: var(--novel-stone-600);\n}\n.novel-p-1 {\n  padding: 0.25rem;\n}\n.novel-p-2 {\n  padding: 0.5rem;\n}\n.novel-p-5 {\n  padding: 1.25rem;\n}\n.novel-px-1 {\n  padding-left: 0.25rem;\n  padding-right: 0.25rem;\n}\n.novel-px-1\\.5 {\n  padding-left: 0.375rem;\n  padding-right: 0.375rem;\n}\n.novel-px-2 {\n  padding-left: 0.5rem;\n  padding-right: 0.5rem;\n}\n.novel-px-3 {\n  padding-left: 0.75rem;\n  padding-right: 0.75rem;\n}\n.novel-py-1 {\n  padding-top: 0.25rem;\n  padding-bottom: 0.25rem;\n}\n.novel-py-1\\.5 {\n  padding-top: 0.375rem;\n  padding-bottom: 0.375rem;\n}\n.novel-py-2 {\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n}\n.novel-py-px {\n  padding-top: 1px;\n  padding-bottom: 1px;\n}\n.novel-pl-2 {\n  padding-left: 0.5rem;\n}\n.novel-text-left {\n  text-align: left;\n}\n.novel-font-default {\n  font-family:\n    var(--font-default),\n    system-ui,\n    sans-serif;\n}\n.novel-font-mono {\n  font-family:\n    ui-monospace,\n    SFMono-Regular,\n    Menlo,\n    Monaco,\n    Consolas,\n    "Liberation Mono",\n    "Courier New",\n    monospace;\n}\n.novel-text-base {\n  font-size: 1rem;\n  line-height: 1.5rem;\n}\n.novel-text-sm {\n  font-size: 0.875rem;\n  line-height: 1.25rem;\n}\n.novel-text-xs {\n  font-size: 0.75rem;\n  line-height: 1rem;\n}\n.novel-font-medium {\n  font-weight: 500;\n}\n.novel-leading-3 {\n  line-height: .75rem;\n}\n.novel-leading-normal {\n  line-height: 1.5;\n}\n.novel-text-blue-500 {\n  --tw-text-opacity: 1;\n  color: rgb(59 130 246 / var(--tw-text-opacity));\n}\n.novel-text-red-600 {\n  --tw-text-opacity: 1;\n  color: rgb(220 38 38 / var(--tw-text-opacity));\n}\n.novel-text-stone-200 {\n  color: var(--novel-stone-200);\n}\n.novel-text-stone-400 {\n  color: var(--novel-stone-400);\n}\n.novel-text-stone-500 {\n  color: var(--novel-stone-500);\n}\n.novel-text-stone-600 {\n  color: var(--novel-stone-600);\n}\n.novel-text-stone-800 {\n  color: var(--novel-stone-800);\n}\n.novel-text-stone-900 {\n  color: var(--novel-stone-900);\n}\n.novel-underline {\n  text-decoration-line: underline;\n}\n.novel-decoration-stone-400 {\n  text-decoration-color: var(--novel-stone-400);\n}\n.novel-underline-offset-4 {\n  text-underline-offset: 4px;\n}\n.novel-underline-offset-\\[3px\\] {\n  text-underline-offset: 3px;\n}\n.novel-shadow-md {\n  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);\n  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);\n  box-shadow:\n    var(--tw-ring-offset-shadow, 0 0 #0000),\n    var(--tw-ring-shadow, 0 0 #0000),\n    var(--tw-shadow);\n}\n.novel-shadow-xl {\n  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);\n  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);\n  box-shadow:\n    var(--tw-ring-offset-shadow, 0 0 #0000),\n    var(--tw-ring-shadow, 0 0 #0000),\n    var(--tw-shadow);\n}\n.novel-outline-none {\n  outline: 2px solid transparent;\n  outline-offset: 2px;\n}\n.novel-transition-all {\n  transition-property: all;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  transition-duration: 150ms;\n}\n.novel-transition-colors {\n  transition-property:\n    color,\n    background-color,\n    border-color,\n    text-decoration-color,\n    fill,\n    stroke;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  transition-duration: 150ms;\n}\n@keyframes enter {\n  from {\n    opacity: var(--tw-enter-opacity, 1);\n    transform: translate3d(var(--tw-enter-translate-x, 0), var(--tw-enter-translate-y, 0), 0) scale3d(var(--tw-enter-scale, 1), var(--tw-enter-scale, 1), var(--tw-enter-scale, 1)) rotate(var(--tw-enter-rotate, 0));\n  }\n}\n@keyframes exit {\n  to {\n    opacity: var(--tw-exit-opacity, 1);\n    transform: translate3d(var(--tw-exit-translate-x, 0), var(--tw-exit-translate-y, 0), 0) scale3d(var(--tw-exit-scale, 1), var(--tw-exit-scale, 1), var(--tw-exit-scale, 1)) rotate(var(--tw-exit-rotate, 0));\n  }\n}\n.novel-animate-in {\n  animation-name: enter;\n  animation-duration: 150ms;\n  --tw-enter-opacity: initial;\n  --tw-enter-scale: initial;\n  --tw-enter-rotate: initial;\n  --tw-enter-translate-x: initial;\n  --tw-enter-translate-y: initial;\n}\n.novel-fade-in {\n  --tw-enter-opacity: 0;\n}\n.novel-slide-in-from-top-1 {\n  --tw-enter-translate-y: -0.25rem;\n}\n.dark\\:novel-prose-invert:is(.novel-dark-theme *) {\n  --tw-prose-body: var(--tw-prose-invert-body);\n  --tw-prose-headings: var(--tw-prose-invert-headings);\n  --tw-prose-lead: var(--tw-prose-invert-lead);\n  --tw-prose-links: var(--tw-prose-invert-links);\n  --tw-prose-bold: var(--tw-prose-invert-bold);\n  --tw-prose-counters: var(--tw-prose-invert-counters);\n  --tw-prose-bullets: var(--tw-prose-invert-bullets);\n  --tw-prose-hr: var(--tw-prose-invert-hr);\n  --tw-prose-quotes: var(--tw-prose-invert-quotes);\n  --tw-prose-quote-borders: var(--tw-prose-invert-quote-borders);\n  --tw-prose-captions: var(--tw-prose-invert-captions);\n  --tw-prose-kbd: var(--tw-prose-invert-kbd);\n  --tw-prose-kbd-shadows: var(--tw-prose-invert-kbd-shadows);\n  --tw-prose-code: var(--tw-prose-invert-code);\n  --tw-prose-pre-code: var(--tw-prose-invert-pre-code);\n  --tw-prose-pre-bg: var(--tw-prose-invert-pre-bg);\n  --tw-prose-th-borders: var(--tw-prose-invert-th-borders);\n  --tw-prose-td-borders: var(--tw-prose-invert-td-borders);\n}\n.hover\\:novel-bg-red-100:hover {\n  --tw-bg-opacity: 1;\n  background-color: rgb(254 226 226 / var(--tw-bg-opacity));\n}\n.hover\\:novel-bg-stone-100:hover {\n  background-color: var(--novel-stone-100);\n}\n.hover\\:novel-text-stone-600:hover {\n  color: var(--novel-stone-600);\n}\n.focus\\:novel-outline-none:focus {\n  outline: 2px solid transparent;\n  outline-offset: 2px;\n}\n.active\\:novel-bg-stone-200:active {\n  background-color: var(--novel-stone-200);\n}\n.prose-headings\\:novel-font-title :is(:where(h1, h2, h3, h4, h5, h6, th):not(:where([class~=novel-not-prose], [class~=novel-not-prose] *))) {\n  font-family:\n    var(--font-title),\n    system-ui,\n    sans-serif;\n}\n.dark\\:hover\\:novel-bg-red-800:hover:is(.novel-dark-theme *) {\n  --tw-bg-opacity: 1;\n  background-color: rgb(153 27 27 / var(--tw-bg-opacity));\n}\n@media (min-width: 640px) {\n  .sm\\:novel-mb-0 {\n    margin-bottom: 0px;\n  }\n  .sm\\:novel-rounded-lg {\n    border-radius: 0.5rem;\n  }\n  .sm\\:novel-border {\n    border-width: 1px;\n  }\n  .sm\\:novel-shadow-lg {\n    --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);\n    --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);\n    box-shadow:\n      var(--tw-ring-offset-shadow, 0 0 #0000),\n      var(--tw-ring-shadow, 0 0 #0000),\n      var(--tw-shadow);\n  }\n}\n');

// src/styles/prosemirror.css
styleInject(`.ProseMirror {
  padding: 3rem;
  padding-left: 2rem;
  padding-right: 2rem;
}
@media (min-width: 640px) {
  .ProseMirror {
    padding-left: 3rem;
    padding-right: 3rem;
  }
}
.ProseMirror .is-editor-empty:first-child::before {
  content: attr(data-placeholder);
  float: left;
  color: var(--novel-stone-400);
  pointer-events: none;
  height: 0;
}
.ProseMirror .is-empty::before {
  content: attr(data-placeholder);
  float: left;
  color: var(--novel-stone-400);
  pointer-events: none;
  height: 0;
}
.ProseMirror img {
  transition: filter 0.1s ease-in-out;
  &:hover {
    cursor: pointer;
    filter: brightness(90%);
  }
  &.ProseMirror-selectednode {
    outline: 3px solid #5abbf7;
    filter: brightness(90%);
  }
}
.img-placeholder {
  position: relative;
  &:before {
    content: "";
    box-sizing: border-box;
    position: absolute;
    top: 50%;
    left: 50%;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    border: 3px solid var(--novel-stone-200);
    border-top-color: var(--novel-stone-800);
    animation: spinning 0.6s linear infinite;
  }
}
@keyframes spinning {
  to {
    transform: rotate(360deg);
  }
}
ul[data-type=taskList] li > label {
  margin-right: 0.2rem;
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
}
@media screen and (max-width: 768px) {
  ul[data-type=taskList] li > label {
    margin-right: 0.5rem;
  }
}
ul[data-type=taskList] li > label input[type=checkbox] {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background-color: var(--novel-white);
  margin: 0;
  cursor: pointer;
  width: 1.2em;
  height: 1.2em;
  position: relative;
  top: 5px;
  border: 2px solid var(--novel-stone-900);
  margin-right: 0.3rem;
  display: grid;
  place-content: center;
  &:hover {
    background-color: var(--novel-stone-50);
  }
  &:active {
    background-color: var(--novel-stone-200);
  }
  &::before {
    content: "";
    width: 0.65em;
    height: 0.65em;
    transform: scale(0);
    transition: 120ms transform ease-in-out;
    box-shadow: inset 1em 1em;
    transform-origin: center;
    clip-path: polygon(14% 44%, 0 65%, 50% 100%, 100% 16%, 80% 0%, 43% 62%);
  }
  &:checked::before {
    transform: scale(1);
  }
}
ul[data-type=taskList] li[data-checked=true] > div > p {
  color: var(--novel-stone-400);
  text-decoration: line-through;
  text-decoration-thickness: 2px;
}
.tippy-box {
  max-width: 400px !important;
}
.ProseMirror:not(.dragging) .ProseMirror-selectednode {
  outline: none !important;
  border-radius: 0.2rem;
  background-color: var(--novel-highlight-blue);
  transition: background-color 0.2s;
  box-shadow: none;
}
.drag-handle {
  position: fixed;
  opacity: 1;
  transition: opacity ease-in 0.2s;
  border-radius: 0.25rem;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 10 10' style='fill: rgba(0, 0, 0, 0.5)'%3E%3Cpath d='M3,2 C2.44771525,2 2,1.55228475 2,1 C2,0.44771525 2.44771525,0 3,0 C3.55228475,0 4,0.44771525 4,1 C4,1.55228475 3.55228475,2 3,2 Z M3,6 C2.44771525,6 2,5.55228475 2,5 C2,4.44771525 2.44771525,4 3,4 C3.55228475,4 4,4.44771525 4,5 C4,5.55228475 3.55228475,6 3,6 Z M3,10 C2.44771525,10 2,9.55228475 2,9 C2,8.44771525 2.44771525,8 3,8 C3.55228475,8 4,8.44771525 4,9 C4,9.55228475 3.55228475,10 3,10 Z M7,2 C6.44771525,2 6,1.55228475 6,1 C6,0.44771525 6.44771525,0 7,0 C7.55228475,0 8,0.44771525 8,1 C8,1.55228475 7.55228475,2 7,2 Z M7,6 C6.44771525,6 6,5.55228475 6,5 C6,4.44771525 6.44771525,4 7,4 C7.55228475,4 8,4.44771525 8,5 C8,5.55228475 7.55228475,6 7,6 Z M7,10 C6.44771525,10 6,9.55228475 6,9 C6,8.44771525 6.44771525,8 7,8 C7.55228475,8 8,8.44771525 8,9 C8,9.55228475 7.55228475,10 7,10 Z'%3E%3C/path%3E%3C/svg%3E");
  background-size: calc(0.5em + 0.375rem) calc(0.5em + 0.375rem);
  background-repeat: no-repeat;
  background-position: center;
  width: 1.2rem;
  height: 1.5rem;
  z-index: 50;
  cursor: grab;
  &:hover {
    background-color: var(--novel-stone-100);
    transition: background-color 0.2s;
  }
  &:active {
    background-color: var(--novel-stone-200);
    transition: background-color 0.2s;
  }
  &.hide {
    opacity: 0;
    pointer-events: none;
  }
  @media screen and (max-width: 600px) {
    display: none;
    pointer-events: none;
  }
}
.dark-theme .drag-handle {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 10 10' style='fill: rgba(255, 255, 255, 0.5)'%3E%3Cpath d='M3,2 C2.44771525,2 2,1.55228475 2,1 C2,0.44771525 2.44771525,0 3,0 C3.55228475,0 4,0.44771525 4,1 C4,1.55228475 3.55228475,2 3,2 Z M3,6 C2.44771525,6 2,5.55228475 2,5 C2,4.44771525 2.44771525,4 3,4 C3.55228475,4 4,4.44771525 4,5 C4,5.55228475 3.55228475,6 3,6 Z M3,10 C2.44771525,10 2,9.55228475 2,9 C2,8.44771525 2.44771525,8 3,8 C3.55228475,8 4,8.44771525 4,9 C4,9.55228475 3.55228475,10 3,10 Z M7,2 C6.44771525,2 6,1.55228475 6,1 C6,0.44771525 6.44771525,0 7,0 C7.55228475,0 8,0.44771525 8,1 C8,1.55228475 7.55228475,2 7,2 Z M7,6 C6.44771525,6 6,5.55228475 6,5 C6,4.44771525 6.44771525,4 7,4 C7.55228475,4 8,4.44771525 8,5 C8,5.55228475 7.55228475,6 7,6 Z M7,10 C6.44771525,10 6,9.55228475 6,9 C6,8.44771525 6.44771525,8 7,8 C7.55228475,8 8,8.44771525 8,9 C8,9.55228475 7.55228475,10 7,10 Z'%3E%3C/path%3E%3C/svg%3E");
}
`);

// src/ui/editor/index.tsx
import { useEffect as useEffect4, useRef as useRef3, useState as useState4 } from "react";

// src/ui/editor/plugins/upload-images.tsx
import { toast } from "sonner";
import { Plugin, PluginKey } from "@tiptap/pm/state";
import { Decoration, DecorationSet } from "@tiptap/pm/view";
import { v4 as uuidv4 } from "uuid";
import { getAuth } from "firebase/auth";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
var uploadKey = new PluginKey("upload-image");
var UploadImagesPlugin = () => new Plugin({
  key: uploadKey,
  state: {
    init() {
      return DecorationSet.empty;
    },
    apply(tr, set) {
      set = set.map(tr.mapping, tr.doc);
      const action = tr.getMeta(this);
      if (action && action.add) {
        const { id, pos, src } = action.add;
        const placeholder = document.createElement("div");
        placeholder.setAttribute("class", "img-placeholder");
        const image = document.createElement("img");
        image.setAttribute(
          "class",
          "opacity-40 rounded-lg border border-stone-200"
        );
        image.src = src;
        placeholder.appendChild(image);
        const deco = Decoration.widget(pos + 1, placeholder, {
          id
        });
        set = set.add(tr.doc, [deco]);
      } else if (action && action.remove) {
        set = set.remove(
          set.find(null, null, (spec) => spec.id == action.remove.id)
        );
      }
      return set;
    }
  },
  props: {
    decorations(state) {
      return this.getState(state);
    }
  }
});
var upload_images_default = UploadImagesPlugin;
function findPlaceholder(state, id) {
  const decos = uploadKey.getState(state);
  const found = decos.find(null, null, (spec) => spec.id == id);
  return found.length ? found[0].from : null;
}
function startImageUpload(file, view, pos) {
  if (!file.type.includes("image/")) {
    toast.error("File type not supported.");
    return;
  } else if (file.size / 1024 / 1024 > 20) {
    toast.error("File size too big (max 20MB).");
    return;
  }
  const user = getAuth().currentUser;
  if (user === null) {
    toast.error("You must be signed in to upload images.");
    return;
  }
  const id = {};
  const tr = view.state.tr;
  if (!tr.selection.empty)
    tr.deleteSelection();
  const reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = () => {
    tr.setMeta(uploadKey, {
      add: {
        id,
        pos,
        src: reader.result
      }
    });
    view.dispatch(tr);
  };
  handleImageUpload(file).then((src) => {
    const { schema } = view.state;
    let pos2 = findPlaceholder(view.state, id);
    if (pos2 == null)
      return;
    const imageSrc = typeof src === "object" ? reader.result : src;
    const node = schema.nodes.image.create({ src: imageSrc });
    const transaction = view.state.tr.replaceWith(pos2, pos2, node).setMeta(uploadKey, { remove: { id } });
    view.dispatch(transaction);
  });
}
var handleImageUpload = (file) => {
  return new Promise((resolve, reject) => {
    const storage = getStorage();
    const user = getAuth().currentUser;
    const userId = user ? user.uid : uuidv4();
    const originalFileName = file.name || "image.png";
    const fileExtension = originalFileName.split(".").pop();
    const uniqueFileName = `${originalFileName.replace(`.${fileExtension}`, "")}-${uuidv4()}.${fileExtension}`;
    const storageRef = ref(storage, `images/${userId}/${uniqueFileName}`);
    toast.promise(
      uploadBytes(storageRef, file).then((snapshot) => {
        return getDownloadURL(snapshot.ref);
      }).then((downloadURL) => {
        resolve(downloadURL);
      }).catch((error) => {
        reject(error);
        throw new Error(`Error uploading image. Please try again.`);
      }),
      {
        loading: "Uploading image...",
        success: "Image uploaded successfully.",
        error: (e) => e.message
      }
    );
  });
};

// src/ui/editor/props.ts
var defaultEditorProps = {
  attributes: {
    class: `novel-prose-lg novel-prose-stone dark:novel-prose-invert prose-headings:novel-font-title novel-font-default focus:novel-outline-none novel-max-w-full`
  },
  handleDOMEvents: {
    keydown: (_view, event) => {
      if (["ArrowUp", "ArrowDown", "Enter"].includes(event.key)) {
        const slashCommand = document.querySelector("#slash-command");
        if (slashCommand) {
          return true;
        }
      }
    }
  },
  handlePaste: (view, event) => {
    if (event.clipboardData && event.clipboardData.files && event.clipboardData.files[0]) {
      event.preventDefault();
      const file = event.clipboardData.files[0];
      const pos = view.state.selection.from;
      startImageUpload(file, view, pos);
      return true;
    }
    return false;
  },
  handleDrop: (view, event, _slice, moved) => {
    if (!moved && event.dataTransfer && event.dataTransfer.files && event.dataTransfer.files[0]) {
      event.preventDefault();
      const file = event.dataTransfer.files[0];
      const coordinates = view.posAtCoords({
        left: event.clientX,
        top: event.clientY
      });
      startImageUpload(file, view, (coordinates == null ? void 0 : coordinates.pos) || 0 - 1);
      return true;
    }
    return false;
  }
};

// src/ui/editor/extensions/index.tsx
import StarterKit from "@tiptap/starter-kit";
import HorizontalRule from "@tiptap/extension-horizontal-rule";
import TiptapLink from "@tiptap/extension-link";
import TiptapImage from "@tiptap/extension-image";
import Placeholder from "@tiptap/extension-placeholder";
import TiptapUnderline from "@tiptap/extension-underline";
import TextStyle from "@tiptap/extension-text-style";
import { Color } from "@tiptap/extension-color";
import TaskItem from "@tiptap/extension-task-item";
import TaskList from "@tiptap/extension-task-list";
import { Markdown } from "tiptap-markdown";
import Highlight from "@tiptap/extension-highlight";

// src/ui/editor/extensions/slash-command.tsx
import {
  useState,
  useEffect,
  useCallback,
  useRef,
  useLayoutEffect,
  useContext
} from "react";
import { Extension } from "@tiptap/core";
import Suggestion from "@tiptap/suggestion";
import { ReactRenderer } from "@tiptap/react";
import { useCompletion } from "ai/react";
import tippy from "tippy.js";
import {
  Heading1,
  Heading2,
  Heading3,
  List,
  ListOrdered,
  Text,
  TextQuote,
  Image as ImageIcon,
  Code,
  CheckSquare,
  CalendarPlusIcon,
  GoalIcon
} from "lucide-react";

// src/ui/icons/loading-circle.tsx
import { jsx, jsxs } from "react/jsx-runtime";
function LoadingCircle({ dimensions }) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      "aria-hidden": "true",
      className: `${dimensions || "novel-h-4 novel-w-4"} novel-animate-spin novel-fill-stone-600 novel-text-stone-200`,
      viewBox: "0 0 100 101",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z",
            fill: "currentFill"
          }
        )
      ]
    }
  );
}

// src/ui/icons/magic.tsx
import { jsx as jsx2, jsxs as jsxs2 } from "react/jsx-runtime";
function Magic({ className }) {
  return /* @__PURE__ */ jsxs2(
    "svg",
    {
      width: "469",
      height: "469",
      viewBox: "0 0 469 469",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      shapeRendering: "geometricPrecision",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5",
      className,
      children: [
        /* @__PURE__ */ jsx2(
          "path",
          {
            d: "M237.092 62.3004L266.754 71.4198C267.156 71.5285 267.51 71.765 267.765 72.0934C268.02 72.4218 268.161 72.8243 268.166 73.2399C268.172 73.6555 268.042 74.0616 267.796 74.3967C267.55 74.7318 267.201 74.9777 266.803 75.097L237.141 84.3145C236.84 84.4058 236.566 84.5699 236.344 84.7922C236.121 85.0146 235.957 85.2883 235.866 85.5893L226.747 115.252C226.638 115.653 226.401 116.008 226.073 116.263C225.745 116.517 225.342 116.658 224.926 116.664C224.511 116.669 224.105 116.539 223.77 116.293C223.435 116.047 223.189 115.699 223.069 115.301L213.852 85.6383C213.761 85.3374 213.597 85.0636 213.374 84.8412C213.152 84.6189 212.878 84.4548 212.577 84.3635L182.914 75.2441C182.513 75.1354 182.158 74.8989 181.904 74.5705C181.649 74.2421 181.508 73.8396 181.503 73.424C181.497 73.0084 181.627 72.6023 181.873 72.2672C182.119 71.9321 182.467 71.6863 182.865 71.5669L212.528 62.3494C212.829 62.2582 213.103 62.0941 213.325 61.8717C213.547 61.6494 213.712 61.3756 213.803 61.0747L222.922 31.4121C223.031 31.0109 223.267 30.656 223.596 30.4013C223.924 30.1465 224.327 30.0057 224.742 30.0002C225.158 29.9946 225.564 30.1247 225.899 30.3706C226.234 30.6165 226.48 30.9649 226.599 31.363L235.817 61.0257C235.908 61.3266 236.072 61.6003 236.295 61.8227C236.517 62.0451 236.791 62.2091 237.092 62.3004Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ jsx2(
          "path",
          {
            d: "M155.948 155.848L202.771 168.939C203.449 169.131 204.045 169.539 204.47 170.101C204.895 170.663 205.125 171.348 205.125 172.052C205.125 172.757 204.895 173.442 204.47 174.004C204.045 174.566 203.449 174.974 202.771 175.166L155.899 188.06C155.361 188.209 154.87 188.496 154.475 188.891C154.079 189.286 153.793 189.777 153.644 190.316L140.553 237.138C140.361 237.816 139.953 238.413 139.391 238.838C138.829 239.262 138.144 239.492 137.44 239.492C136.735 239.492 136.05 239.262 135.488 238.838C134.927 238.413 134.519 237.816 134.327 237.138L121.432 190.267C121.283 189.728 120.997 189.237 120.601 188.842C120.206 188.446 119.715 188.16 119.177 188.011L72.3537 174.92C71.676 174.728 71.0795 174.32 70.6547 173.759C70.2299 173.197 70 172.512 70 171.807C70 171.103 70.2299 170.418 70.6547 169.856C71.0795 169.294 71.676 168.886 72.3537 168.694L119.226 155.799C119.764 155.65 120.255 155.364 120.65 154.969C121.046 154.573 121.332 154.082 121.481 153.544L134.572 106.721C134.764 106.043 135.172 105.447 135.734 105.022C136.295 104.597 136.981 104.367 137.685 104.367C138.389 104.367 139.075 104.597 139.637 105.022C140.198 105.447 140.606 106.043 140.798 106.721L153.693 153.593C153.842 154.131 154.128 154.622 154.524 155.018C154.919 155.413 155.41 155.699 155.948 155.848Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ jsx2(
          "path",
          {
            d: "M386.827 289.992C404.33 292.149 403.84 305.828 386.876 307.299C346.623 310.829 298.869 316.271 282.199 360.005C274.844 379.192 269.942 403.2 267.49 432.029C267.427 432.846 267.211 433.626 266.856 434.319C266.501 435.012 266.015 435.602 265.431 436.05C254.988 444.041 251.212 434.186 250.183 425.606C239.2 332.353 214.588 316.909 124.668 306.122C123.892 306.031 123.151 305.767 122.504 305.35C121.857 304.933 121.322 304.375 120.942 303.72C116.399 295.679 119.324 291.038 129.718 289.796C224.688 278.47 236.062 262.83 250.183 169.331C252.177 156.355 257.259 154.083 265.431 162.516C266.51 163.593 267.202 165.099 267.392 166.782C279.257 258.564 293.328 278.617 386.827 289.992Z",
            fill: "currentColor"
          }
        )
      ]
    }
  );
}

// src/ui/editor/extensions/slash-command.tsx
import { toast as toast2 } from "sonner";

// src/lib/editor.ts
var getPrevText = (editor, {
  chars,
  offset = 0
}) => {
  return editor.state.doc.textBetween(
    Math.max(0, editor.state.selection.from - chars),
    editor.state.selection.from - offset,
    "\n"
  );
};

// src/ui/editor/provider.tsx
import { createContext } from "react";
var NovelContext = createContext({
  completionApi: "/api/generate",
  breakApi: "/api/break",
  editorTitle: "",
  editorTimeRange: ""
});

// src/ui/editor/extensions/slash-command.tsx
import { jsx as jsx3, jsxs as jsxs3 } from "react/jsx-runtime";
var Command = Extension.create({
  name: "slash-command",
  addOptions() {
    return {
      suggestion: {
        char: "/",
        command: ({
          editor,
          range,
          props
        }) => {
          props.command({ editor, range });
        }
      }
    };
  },
  addProseMirrorPlugins() {
    return [
      Suggestion(__spreadValues({
        editor: this.editor
      }, this.options.suggestion))
    ];
  }
});
var getSuggestionItems = ({ query }) => {
  return [
    {
      title: "Break It Down",
      description: "Use AI to break down an outcome into tasks.",
      searchTerms: ["bid"],
      icon: /* @__PURE__ */ jsx3(Magic, { className: "novel-w-7" })
    },
    {
      title: "Goal Title",
      description: "Insert Goal title.",
      searchTerms: ["goal"],
      icon: /* @__PURE__ */ jsx3(GoalIcon, { size: 18 })
    },
    {
      title: "Time Range",
      description: "Insert milestone time range.",
      searchTerms: ["time range"],
      icon: /* @__PURE__ */ jsx3(CalendarPlusIcon, { size: 18 })
    },
    {
      title: "Image",
      description: "Upload an image from your computer.",
      searchTerms: ["photo", "picture", "media"],
      icon: /* @__PURE__ */ jsx3(ImageIcon, { size: 18 }),
      command: ({ editor, range }) => {
        editor.chain().focus().deleteRange(range).run();
        const input = document.createElement("input");
        input.type = "file";
        input.accept = "image/*";
        input.onchange = () => __async(void 0, null, function* () {
          var _a;
          if ((_a = input.files) == null ? void 0 : _a.length) {
            const file = input.files[0];
            const pos = editor.view.state.selection.from;
            startImageUpload(file, editor.view, pos);
          }
        });
        input.click();
      }
    },
    {
      title: "To-do List",
      description: "Track tasks with a to-do list.",
      searchTerms: ["todo", "task", "list", "check", "checkbox"],
      icon: /* @__PURE__ */ jsx3(CheckSquare, { size: 18 }),
      command: ({ editor, range }) => {
        editor.chain().focus().deleteRange(range).toggleTaskList().run();
      }
    },
    {
      title: "Heading 1",
      description: "Big section heading.",
      searchTerms: ["title", "big", "large"],
      icon: /* @__PURE__ */ jsx3(Heading1, { size: 18 }),
      command: ({ editor, range }) => {
        editor.chain().focus().deleteRange(range).setNode("heading", { level: 1 }).run();
      }
    },
    {
      title: "Heading 2",
      description: "Medium section heading.",
      searchTerms: ["subtitle", "medium"],
      icon: /* @__PURE__ */ jsx3(Heading2, { size: 18 }),
      command: ({ editor, range }) => {
        editor.chain().focus().deleteRange(range).setNode("heading", { level: 2 }).run();
      }
    },
    {
      title: "Heading 3",
      description: "Small section heading.",
      searchTerms: ["subtitle", "small"],
      icon: /* @__PURE__ */ jsx3(Heading3, { size: 18 }),
      command: ({ editor, range }) => {
        editor.chain().focus().deleteRange(range).setNode("heading", { level: 3 }).run();
      }
    },
    {
      title: "Text",
      description: "Just start typing with plain text.",
      searchTerms: ["p", "paragraph"],
      icon: /* @__PURE__ */ jsx3(Text, { size: 18 }),
      command: ({ editor, range }) => {
        editor.chain().focus().deleteRange(range).toggleNode("paragraph", "paragraph").run();
      }
    },
    {
      title: "Bullet List",
      description: "Create a simple bullet list.",
      searchTerms: ["unordered", "point"],
      icon: /* @__PURE__ */ jsx3(List, { size: 18 }),
      command: ({ editor, range }) => {
        editor.chain().focus().deleteRange(range).toggleBulletList().run();
      }
    },
    {
      title: "Numbered List",
      description: "Create a list with numbering.",
      searchTerms: ["ordered"],
      icon: /* @__PURE__ */ jsx3(ListOrdered, { size: 18 }),
      command: ({ editor, range }) => {
        editor.chain().focus().deleteRange(range).toggleOrderedList().run();
      }
    },
    {
      title: "Quote",
      description: "Capture a quote.",
      searchTerms: ["blockquote"],
      icon: /* @__PURE__ */ jsx3(TextQuote, { size: 18 }),
      command: ({ editor, range }) => editor.chain().focus().deleteRange(range).toggleNode("paragraph", "paragraph").toggleBlockquote().run()
    },
    {
      title: "Code",
      description: "Capture a code snippet.",
      searchTerms: ["codeblock"],
      icon: /* @__PURE__ */ jsx3(Code, { size: 18 }),
      command: ({ editor, range }) => editor.chain().focus().deleteRange(range).toggleCodeBlock().run()
    },
    {
      title: "Continue writing",
      description: "Use AI to expand your thoughts.",
      searchTerms: ["gpt"],
      icon: /* @__PURE__ */ jsx3(Magic, { className: "novel-w-7" })
    }
  ].filter((item) => {
    if (typeof query === "string" && query.length > 0) {
      const search = query.toLowerCase();
      return item.title.toLowerCase().includes(search) || item.description.toLowerCase().includes(search) || item.searchTerms && item.searchTerms.some((term) => term.includes(search));
    }
    return true;
  });
};
var updateScrollView = (container, item) => {
  const containerHeight = container.offsetHeight;
  const itemHeight = item ? item.offsetHeight : 0;
  const top = item.offsetTop;
  const bottom = top + itemHeight;
  if (top < container.scrollTop) {
    container.scrollTop -= container.scrollTop - top + 5;
  } else if (bottom > containerHeight + container.scrollTop) {
    container.scrollTop += bottom - containerHeight - container.scrollTop + 5;
  }
};
var CommandList = ({
  items,
  command,
  editor,
  range
}) => {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const { completionApi, breakApi, editorTitle, editorTimeRange } = useContext(NovelContext);
  const { complete: completeContinueWriting, isLoading: isContinueWritingLoading } = useCompletion({
    id: "continue",
    api: completionApi,
    onResponse: (response) => {
      if (response.status === 429) {
        toast2.error("You have reached your request limit for the day.");
        return;
      }
      editor.chain().focus().deleteRange(range).run();
    },
    onFinish: (_prompt, completion) => {
      editor.commands.setTextSelection({
        from: range.from,
        to: range.from + completion.length
      });
    },
    onError: (e) => {
      toast2.error(e.message);
    }
  });
  const { complete: completeBreakItDown, isLoading: isBreakItDownLoading } = useCompletion({
    id: "break",
    api: breakApi,
    onResponse: (response) => {
      if (response.status === 429) {
        toast2.error("You have reached your request limit for the day.");
        return;
      }
    },
    onFinish: (_prompt, completion) => {
      editor.chain().focus().deleteRange(range).run();
      editor.chain().insertContent(completion).run();
    },
    onError: (e) => {
      toast2.error(e.message);
    }
  });
  const selectItem = useCallback(
    (index) => __async(void 0, null, function* () {
      var _a, _b;
      const item = items[index];
      if (item) {
        if (item.title === "Goal Title") {
          const previousNodeType = (_a = editor.state.doc.resolve(range.from).nodeBefore) == null ? void 0 : _a.type.name;
          editor.commands.deleteRange(range);
          editor.commands.setNode("heading", { level: 3 });
          editor.commands.insertContent(editorTitle);
          editor.commands.insertContent("\n");
          editor.commands.setNode(previousNodeType || "paragraph");
        } else if (item.title === "Time Range") {
          const previousNodeType = (_b = editor.state.doc.resolve(range.from).nodeBefore) == null ? void 0 : _b.type.name;
          editor.commands.deleteRange(range);
          editor.commands.setNode("heading", { level: 4 });
          editor.commands.insertContent(editorTimeRange);
          editor.commands.insertContent("\n");
          editor.commands.setNode(previousNodeType || "paragraph");
        } else if (item.title === "Continue writing") {
          if (isContinueWritingLoading)
            return;
          const prevText = getPrevText(editor, {
            chars: 5e3,
            offset: 1
          });
          completeContinueWriting(
            prevText
          );
        } else if (item.title === "Break It Down") {
          if (isBreakItDownLoading)
            return;
          let aiGoal = editorTitle;
          if (!aiGoal && editor) {
            aiGoal = editor.state.doc.textBetween(editor == null ? void 0 : editor.state.selection.from, editor == null ? void 0 : editor.state.selection.to);
          }
          completeBreakItDown(`Goal: ${aiGoal}. Time Range: ${editorTimeRange}.
`);
        } else {
          command(item);
        }
      }
    }),
    [completeContinueWriting, isContinueWritingLoading, completeBreakItDown, isBreakItDownLoading, command, editor, items]
  );
  useEffect(() => {
    const navigationKeys = ["ArrowUp", "ArrowDown", "Enter"];
    const onKeyDown = (e) => {
      if (navigationKeys.includes(e.key)) {
        e.preventDefault();
        if (e.key === "ArrowUp") {
          setSelectedIndex((selectedIndex + items.length - 1) % items.length);
          return true;
        }
        if (e.key === "ArrowDown") {
          setSelectedIndex((selectedIndex + 1) % items.length);
          return true;
        }
        if (e.key === "Enter") {
          selectItem(selectedIndex);
          return true;
        }
        return false;
      }
    };
    document.addEventListener("keydown", onKeyDown);
    return () => {
      document.removeEventListener("keydown", onKeyDown);
    };
  }, [items, selectedIndex, setSelectedIndex, selectItem]);
  useEffect(() => {
    setSelectedIndex(0);
  }, [items]);
  const commandListContainer = useRef(null);
  useLayoutEffect(() => {
    const container = commandListContainer == null ? void 0 : commandListContainer.current;
    const item = container == null ? void 0 : container.children[selectedIndex];
    if (item && container)
      updateScrollView(container, item);
  }, [selectedIndex]);
  return items.length > 0 ? /* @__PURE__ */ jsx3(
    "div",
    {
      id: "slash-command",
      ref: commandListContainer,
      className: "novel-z-50 novel-h-auto novel-max-h-[330px] novel-w-72 novel-overflow-y-auto novel-rounded-md novel-border novel-border-stone-200 novel-bg-white novel-px-1 novel-py-2 novel-shadow-md novel-transition-all",
      children: items.map((item, index) => {
        return /* @__PURE__ */ jsxs3(
          "button",
          {
            className: `novel-flex novel-w-full novel-items-center novel-space-x-2 novel-rounded-md novel-px-2 novel-py-1 novel-text-left novel-text-sm novel-text-stone-900 hover:novel-bg-stone-100 ${index === selectedIndex ? "novel-bg-stone-100 novel-text-stone-900" : ""}`,
            onClick: () => selectItem(index),
            children: [
              /* @__PURE__ */ jsx3("div", { className: "novel-flex novel-h-10 novel-w-10 novel-items-center novel-justify-center novel-rounded-md novel-border novel-border-stone-200 novel-bg-white", children: (item.title === "Continue writing" || item.title === "Break It Down") && (isContinueWritingLoading || isBreakItDownLoading) ? /* @__PURE__ */ jsx3(LoadingCircle, {}) : item.icon }),
              /* @__PURE__ */ jsxs3("div", { children: [
                /* @__PURE__ */ jsx3("p", { className: "novel-font-medium", children: item.title }),
                /* @__PURE__ */ jsx3("p", { className: "novel-text-xs novel-text-stone-500", children: item.description })
              ] })
            ]
          },
          index
        );
      })
    }
  ) : null;
};
var renderItems = () => {
  let component = null;
  let popup = null;
  return {
    onStart: (props) => {
      component = new ReactRenderer(CommandList, {
        props,
        editor: props.editor
      });
      popup = tippy("body", {
        getReferenceClientRect: props.clientRect,
        appendTo: () => document.body,
        content: component.element,
        showOnCreate: true,
        interactive: true,
        trigger: "manual",
        placement: "bottom-start"
      });
    },
    onUpdate: (props) => {
      component == null ? void 0 : component.updateProps(props);
      popup && popup[0].setProps({
        getReferenceClientRect: props.clientRect
      });
    },
    onKeyDown: (props) => {
      var _a;
      if (props.event.key === "Escape") {
        popup == null ? void 0 : popup[0].hide();
        return true;
      }
      return (_a = component == null ? void 0 : component.ref) == null ? void 0 : _a.onKeyDown(props);
    },
    onExit: () => {
      popup == null ? void 0 : popup[0].destroy();
      component == null ? void 0 : component.destroy();
    }
  };
};
var SlashCommand = Command.configure({
  suggestion: {
    items: getSuggestionItems,
    render: renderItems
  }
});
var slash_command_default = SlashCommand;

// src/ui/editor/extensions/index.tsx
import { InputRule } from "@tiptap/core";

// src/ui/editor/extensions/updated-image.ts
import Image from "@tiptap/extension-image";
var UpdatedImage = Image.extend({
  addAttributes() {
    var _a;
    return __spreadProps(__spreadValues({}, (_a = this.parent) == null ? void 0 : _a.call(this)), {
      width: {
        default: null
      },
      height: {
        default: null
      }
    });
  }
});
var updated_image_default = UpdatedImage;

// src/ui/editor/extensions/custom-keymap.ts
import { Extension as Extension2 } from "@tiptap/core";
var CustomKeymap = Extension2.create({
  name: "CustomKeymap",
  addCommands() {
    return {
      selectTextWithinNodeBoundaries: () => ({ editor, commands }) => {
        const { state } = editor;
        const { tr } = state;
        const startNodePos = tr.selection.$from.start();
        const endNodePos = tr.selection.$to.end();
        return commands.setTextSelection({
          from: startNodePos,
          to: endNodePos
        });
      }
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-a": ({ editor }) => {
        const { state } = editor;
        const { tr } = state;
        const startSelectionPos = tr.selection.from;
        const endSelectionPos = tr.selection.to;
        const startNodePos = tr.selection.$from.start();
        const endNodePos = tr.selection.$to.end();
        const isCurrentTextSelectionNotExtendedToNodeBoundaries = startSelectionPos > startNodePos || endSelectionPos < endNodePos;
        if (isCurrentTextSelectionNotExtendedToNodeBoundaries) {
          editor.chain().selectTextWithinNodeBoundaries().run();
          return true;
        }
        return false;
      }
    };
  }
});
var custom_keymap_default = CustomKeymap;

// src/ui/editor/extensions/index.tsx
import GlobalDragHandle from "tiptap-extension-global-drag-handle";
import AutoJoiner from "tiptap-extension-auto-joiner";
function getDefaultExtensions(enableDragHandle = true) {
  const extensions = [
    StarterKit.configure({
      bulletList: {
        HTMLAttributes: {
          class: "novel-list-disc novel-list-outside novel-leading-3 novel--mt-2"
        }
      },
      orderedList: {
        HTMLAttributes: {
          class: "novel-list-decimal novel-list-outside novel-leading-3 novel--mt-2"
        }
      },
      listItem: {
        HTMLAttributes: {
          class: "novel-leading-normal novel--mb-2"
        }
      },
      blockquote: {
        HTMLAttributes: {
          class: "novel-border-l-4 novel-border-stone-700"
        }
      },
      codeBlock: {
        HTMLAttributes: {
          class: "novel-rounded-sm novel-bg-stone-100 novel-p-5 novel-font-mono novel-font-medium novel-text-stone-800"
        }
      },
      code: {
        HTMLAttributes: {
          class: "novel-rounded-md novel-bg-stone-200 novel-px-1.5 novel-py-1 novel-font-mono novel-font-medium novel-text-stone-900",
          spellcheck: "false"
        }
      },
      horizontalRule: false,
      dropcursor: {
        color: "#DBEAFE",
        width: 4
      },
      gapcursor: false
    }),
    // patch to fix horizontal rule bug: https://github.com/ueberdosis/tiptap/pull/3859#issuecomment-1536799740
    HorizontalRule.extend({
      addInputRules() {
        return [
          new InputRule({
            find: /^(?:---|—-|___\s|\*\*\*\s)$/,
            handler: ({ state, range }) => {
              const attributes = {};
              const { tr } = state;
              const start = range.from;
              let end = range.to;
              tr.insert(start - 1, this.type.create(attributes)).delete(
                tr.mapping.map(start),
                tr.mapping.map(end)
              );
            }
          })
        ];
      }
    }).configure({
      HTMLAttributes: {
        class: "novel-mt-4 novel-mb-6 novel-border-t novel-border-stone-300"
      }
    }),
    TiptapLink.configure({
      HTMLAttributes: {
        class: "novel-text-stone-400 novel-underline novel-underline-offset-[3px] hover:novel-text-stone-600 novel-transition-colors novel-cursor-pointer"
      }
    }),
    TiptapImage.extend({
      addProseMirrorPlugins() {
        return [upload_images_default()];
      }
    }).configure({
      allowBase64: true,
      HTMLAttributes: {
        class: "novel-rounded-lg novel-border novel-border-stone-200"
      }
    }),
    updated_image_default.configure({
      HTMLAttributes: {
        class: "novel-rounded-lg novel-border novel-border-stone-200"
      }
    }),
    Placeholder.configure({
      placeholder: ({ node }) => {
        if (node.type.name === "heading") {
          return `Heading ${node.attrs.level}`;
        }
        return "Press '/' for commands, or '++' for AI autocomplete...";
      },
      includeChildren: true
    }),
    slash_command_default,
    TiptapUnderline,
    TextStyle,
    Color,
    Highlight.configure({
      multicolor: true
    }),
    TaskList.configure({
      HTMLAttributes: {
        class: "novel-not-prose novel-pl-2"
      }
    }),
    TaskItem.configure({
      HTMLAttributes: {
        class: "novel-flex novel-items-start novel-my-4"
      },
      nested: true
    }),
    Markdown.configure({
      html: false,
      transformCopiedText: true,
      transformPastedText: true
    }),
    custom_keymap_default
  ];
  if (enableDragHandle) {
    extensions.push(GlobalDragHandle.configure({
      dragHandleWidth: 20,
      // default
      // The scrollTreshold specifies how close the user must drag an element to the edge of the lower/upper screen for automatic 
      // scrolling to take place. For example, scrollTreshold = 100 means that scrolling starts automatically when the user drags an 
      // element to a position that is max. 99px away from the edge of the screen
      // You can set this to 0 to prevent auto scrolling caused by this extension
      scrollTreshold: 100
      // default
    }));
    extensions.push(AutoJoiner.configure({
      elementsToJoin: ["bulletList", "orderedList"]
      // default
    }));
  }
  return extensions;
}

// src/lib/hooks/use-local-storage.ts
import { useEffect as useEffect2, useState as useState2 } from "react";
var useLocalStorage = (key, initialValue) => {
  const [storedValue, setStoredValue] = useState2(initialValue);
  useEffect2(() => {
    const item = window.localStorage.getItem(key);
    if (item) {
      setStoredValue(JSON.parse(item));
    }
  }, [key]);
  const setValue = (value) => {
    setStoredValue(value);
    window.localStorage.setItem(key, JSON.stringify(value));
  };
  return [storedValue, setValue];
};
var use_local_storage_default = useLocalStorage;

// src/ui/editor/index.tsx
import { useDebouncedCallback } from "use-debounce";
import { useCompletion as useCompletion2 } from "ai/react";
import { toast as toast3 } from "sonner";

// src/ui/editor/bubble-menu/index.tsx
import { BubbleMenu, isNodeSelection } from "@tiptap/react";
import { useState as useState3 } from "react";
import {
  BoldIcon,
  ItalicIcon,
  UnderlineIcon,
  StrikethroughIcon,
  CodeIcon
} from "lucide-react";

// src/ui/editor/bubble-menu/node-selector.tsx
import {
  Check,
  ChevronDown,
  Heading1 as Heading12,
  Heading2 as Heading22,
  Heading3 as Heading32,
  TextQuote as TextQuote2,
  ListOrdered as ListOrdered2,
  TextIcon,
  Code as Code2,
  CheckSquare as CheckSquare2
} from "lucide-react";
import * as Popover from "@radix-ui/react-popover";
import { jsx as jsx4, jsxs as jsxs4 } from "react/jsx-runtime";
var NodeSelector = ({
  editor,
  isOpen,
  setIsOpen
}) => {
  var _a;
  const items = [
    {
      name: "Text",
      icon: TextIcon,
      command: () => editor.chain().focus().toggleNode("paragraph", "paragraph").run(),
      // I feel like there has to be a more efficient way to do this – feel free to PR if you know how!
      isActive: () => editor.isActive("paragraph") && !editor.isActive("bulletList") && !editor.isActive("orderedList")
    },
    {
      name: "Heading 1",
      icon: Heading12,
      command: () => editor.chain().focus().toggleHeading({ level: 1 }).run(),
      isActive: () => editor.isActive("heading", { level: 1 })
    },
    {
      name: "Heading 2",
      icon: Heading22,
      command: () => editor.chain().focus().toggleHeading({ level: 2 }).run(),
      isActive: () => editor.isActive("heading", { level: 2 })
    },
    {
      name: "Heading 3",
      icon: Heading32,
      command: () => editor.chain().focus().toggleHeading({ level: 3 }).run(),
      isActive: () => editor.isActive("heading", { level: 3 })
    },
    {
      name: "To-do List",
      icon: CheckSquare2,
      command: () => editor.chain().focus().toggleTaskList().run(),
      isActive: () => editor.isActive("taskItem")
    },
    {
      name: "Bullet List",
      icon: ListOrdered2,
      command: () => editor.chain().focus().toggleBulletList().run(),
      isActive: () => editor.isActive("bulletList")
    },
    {
      name: "Numbered List",
      icon: ListOrdered2,
      command: () => editor.chain().focus().toggleOrderedList().run(),
      isActive: () => editor.isActive("orderedList")
    },
    {
      name: "Quote",
      icon: TextQuote2,
      command: () => editor.chain().focus().toggleNode("paragraph", "paragraph").toggleBlockquote().run(),
      isActive: () => editor.isActive("blockquote")
    },
    {
      name: "Code",
      icon: Code2,
      command: () => editor.chain().focus().toggleCodeBlock().run(),
      isActive: () => editor.isActive("codeBlock")
    }
  ];
  const activeItem = (_a = items.filter((item) => item.isActive()).pop()) != null ? _a : {
    name: "Multiple"
  };
  return /* @__PURE__ */ jsx4(Popover.Root, { open: isOpen, children: /* @__PURE__ */ jsxs4("div", { className: "novel-relative novel-h-full", children: [
    /* @__PURE__ */ jsxs4(
      Popover.Trigger,
      {
        className: "novel-flex novel-h-full novel-items-center novel-gap-1 novel-whitespace-nowrap novel-p-2 novel-text-sm novel-font-medium novel-text-stone-600 hover:novel-bg-stone-100 active:novel-bg-stone-200",
        onClick: () => setIsOpen(!isOpen),
        children: [
          /* @__PURE__ */ jsx4("span", { children: activeItem == null ? void 0 : activeItem.name }),
          /* @__PURE__ */ jsx4(ChevronDown, { className: "h-4 w-4" })
        ]
      }
    ),
    /* @__PURE__ */ jsx4(
      Popover.Content,
      {
        align: "start",
        className: "novel-z-[99999] novel-my-1 novel-flex novel-max-h-80 novel-w-48 novel-flex-col novel-overflow-hidden novel-overflow-y-auto novel-rounded novel-border novel-border-stone-200 novel-bg-white novel-p-1 novel-shadow-xl novel-animate-in novel-fade-in novel-slide-in-from-top-1",
        children: items.map((item, index) => /* @__PURE__ */ jsxs4(
          "button",
          {
            onClick: () => {
              item.command();
              setIsOpen(false);
            },
            className: "novel-flex novel-items-center novel-justify-between novel-rounded-sm novel-px-2 novel-py-1 novel-text-sm novel-text-stone-600 hover:novel-bg-stone-100",
            type: "button",
            children: [
              /* @__PURE__ */ jsxs4("div", { className: "flex items-center space-x-2", children: [
                /* @__PURE__ */ jsxs4("div", { className: "novel-flex novel-items-center novel-space-x-2", children: [
                  " ",
                  /* @__PURE__ */ jsx4(item.icon, { className: "novel-h-3 novel-w-3" })
                ] }),
                /* @__PURE__ */ jsx4("span", { children: item.name })
              ] }),
              activeItem.name === item.name && /* @__PURE__ */ jsx4(Check, { className: "novel-h-4 novel-w-4" })
            ]
          },
          index
        ))
      }
    )
  ] }) });
};

// src/ui/editor/bubble-menu/color-selector.tsx
import { Check as Check2, ChevronDown as ChevronDown2 } from "lucide-react";
import * as Popover2 from "@radix-ui/react-popover";
import { jsx as jsx5, jsxs as jsxs5 } from "react/jsx-runtime";
var TEXT_COLORS = [
  {
    name: "Default",
    color: "var(--novel-black)"
  },
  {
    name: "Purple",
    color: "#9333EA"
  },
  {
    name: "Red",
    color: "#E00000"
  },
  {
    name: "Yellow",
    color: "#EAB308"
  },
  {
    name: "Blue",
    color: "#2563EB"
  },
  {
    name: "Green",
    color: "#008A00"
  },
  {
    name: "Orange",
    color: "#FFA500"
  },
  {
    name: "Pink",
    color: "#BA4081"
  },
  {
    name: "Gray",
    color: "#A8A29E"
  }
];
var HIGHLIGHT_COLORS = [
  {
    name: "Default",
    color: "var(--novel-highlight-default)"
  },
  {
    name: "Purple",
    color: "var(--novel-highlight-purple)"
  },
  {
    name: "Red",
    color: "var(--novel-highlight-red)"
  },
  {
    name: "Yellow",
    color: "var(--novel-highlight-yellow)"
  },
  {
    name: "Blue",
    color: "var(--novel-highlight-blue)"
  },
  {
    name: "Green",
    color: "var(--novel-highlight-green)"
  },
  {
    name: "Orange",
    color: "var(--novel-highlight-orange)"
  },
  {
    name: "Pink",
    color: "var(--novel-highlight-pink)"
  },
  {
    name: "Gray",
    color: "var(--novel-highlight-gray)"
  }
];
var ColorSelector = ({
  editor,
  isOpen,
  setIsOpen
}) => {
  const activeColorItem = TEXT_COLORS.find(
    ({ color }) => editor.isActive("textStyle", { color })
  );
  const activeHighlightItem = HIGHLIGHT_COLORS.find(
    ({ color }) => editor.isActive("highlight", { color })
  );
  return /* @__PURE__ */ jsx5(Popover2.Root, { open: isOpen, children: /* @__PURE__ */ jsxs5("div", { className: "novel-relative novel-h-full", children: [
    /* @__PURE__ */ jsxs5(
      Popover2.Trigger,
      {
        className: "novel-flex novel-h-full novel-items-center novel-gap-1 novel-p-2 novel-text-sm novel-font-medium novel-text-stone-600 hover:novel-bg-stone-100 active:novel-bg-stone-200",
        onClick: () => setIsOpen(!isOpen),
        children: [
          /* @__PURE__ */ jsx5(
            "span",
            {
              className: "novel-rounded-sm novel-px-1",
              style: {
                color: activeColorItem == null ? void 0 : activeColorItem.color,
                backgroundColor: activeHighlightItem == null ? void 0 : activeHighlightItem.color
              },
              children: "A"
            }
          ),
          /* @__PURE__ */ jsx5(ChevronDown2, { className: "novel-h-4 novel-w-4" })
        ]
      }
    ),
    /* @__PURE__ */ jsxs5(
      Popover2.Content,
      {
        align: "start",
        className: "novel-z-[99999] novel-my-1 novel-flex novel-max-h-80 novel-w-48 novel-flex-col novel-overflow-hidden novel-overflow-y-auto novel-rounded novel-border novel-border-stone-200 novel-bg-white novel-p-1 novel-shadow-xl novel-animate-in novel-fade-in novel-slide-in-from-top-1",
        children: [
          /* @__PURE__ */ jsx5("div", { className: "novel-my-1 novel-px-2 novel-text-sm novel-text-stone-500", children: "Color" }),
          TEXT_COLORS.map(({ name, color }, index) => /* @__PURE__ */ jsxs5(
            "button",
            {
              onClick: () => {
                editor.commands.unsetColor();
                name !== "Default" && editor.chain().focus().setColor(color || "").run();
                setIsOpen(false);
              },
              className: "novel-flex novel-items-center novel-justify-between novel-rounded-sm novel-px-2 novel-py-1 novel-text-sm novel-text-stone-600 hover:novel-bg-stone-100",
              type: "button",
              children: [
                /* @__PURE__ */ jsxs5("div", { className: "novel-flex novel-items-center novel-space-x-2", children: [
                  /* @__PURE__ */ jsx5(
                    "div",
                    {
                      className: "novel-rounded-sm novel-border novel-border-stone-200 novel-px-1 novel-py-px novel-font-medium",
                      style: { color },
                      children: "A"
                    }
                  ),
                  /* @__PURE__ */ jsx5("span", { children: name })
                ] }),
                editor.isActive("textStyle", { color }) && /* @__PURE__ */ jsx5(Check2, { className: "novel-h-4 novel-w-4" })
              ]
            },
            index
          )),
          /* @__PURE__ */ jsx5("div", { className: "novel-mb-1 novel-mt-2 novel-px-2 novel-text-sm novel-text-stone-500", children: "Background" }),
          HIGHLIGHT_COLORS.map(({ name, color }, index) => /* @__PURE__ */ jsxs5(
            "button",
            {
              onClick: () => {
                editor.commands.unsetHighlight();
                name !== "Default" && editor.commands.setHighlight({ color });
                setIsOpen(false);
              },
              className: "novel-flex novel-items-center novel-justify-between novel-rounded-sm novel-px-2 novel-py-1 novel-text-sm novel-text-stone-600 hover:novel-bg-stone-100",
              type: "button",
              children: [
                /* @__PURE__ */ jsxs5("div", { className: "novel-flex novel-items-center novel-space-x-2", children: [
                  /* @__PURE__ */ jsx5(
                    "div",
                    {
                      className: "novel-rounded-sm novel-border novel-border-stone-200 novel-px-1 novel-py-px novel-font-medium",
                      style: { backgroundColor: color },
                      children: "A"
                    }
                  ),
                  /* @__PURE__ */ jsx5("span", { children: name })
                ] }),
                editor.isActive("highlight", { color }) && /* @__PURE__ */ jsx5(Check2, { className: "novel-h-4 novel-w-4" })
              ]
            },
            index
          ))
        ]
      }
    )
  ] }) });
};

// src/lib/utils.ts
import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
function cn(...inputs) {
  return twMerge(clsx(inputs));
}
function isValidUrl(url) {
  try {
    new URL(url);
    return true;
  } catch (e) {
    return false;
  }
}
function getUrlFromString(str) {
  if (isValidUrl(str))
    return str;
  try {
    if (str.includes(".") && !str.includes(" ")) {
      return new URL(`https://${str}`).toString();
    }
  } catch (e) {
    return null;
  }
}

// src/ui/editor/bubble-menu/link-selector.tsx
import { Check as Check3, Trash } from "lucide-react";
import { useEffect as useEffect3, useRef as useRef2 } from "react";
import { jsx as jsx6, jsxs as jsxs6 } from "react/jsx-runtime";
var LinkSelector = ({
  editor,
  isOpen,
  setIsOpen
}) => {
  const inputRef = useRef2(null);
  useEffect3(() => {
    var _a;
    inputRef.current && ((_a = inputRef.current) == null ? void 0 : _a.focus());
  });
  return /* @__PURE__ */ jsxs6("div", { className: "novel-relative", children: [
    /* @__PURE__ */ jsxs6(
      "button",
      {
        type: "button",
        className: "novel-flex novel-h-full novel-items-center novel-space-x-2 novel-px-3 novel-py-1.5 novel-text-sm novel-font-medium novel-text-stone-600 hover:novel-bg-stone-100 active:novel-bg-stone-200",
        onClick: () => {
          setIsOpen(!isOpen);
        },
        children: [
          /* @__PURE__ */ jsx6("p", { className: "novel-text-base", children: "\u2197" }),
          /* @__PURE__ */ jsx6(
            "p",
            {
              className: cn(
                "novel-underline novel-decoration-stone-400 novel-underline-offset-4",
                {
                  "novel-text-blue-500": editor.isActive("link")
                }
              ),
              children: "Link"
            }
          )
        ]
      }
    ),
    isOpen && /* @__PURE__ */ jsxs6(
      "form",
      {
        onSubmit: (e) => {
          e.preventDefault();
          const input = e.currentTarget[0];
          const url = getUrlFromString(input.value);
          url && editor.chain().focus().setLink({ href: url }).run();
          setIsOpen(false);
        },
        className: "novel-fixed novel-top-full novel-z-[99999] novel-mt-1 novel-flex novel-w-60 novel-overflow-hidden novel-rounded novel-border novel-border-stone-200 novel-bg-white novel-p-1 novel-shadow-xl novel-animate-in novel-fade-in novel-slide-in-from-top-1",
        children: [
          /* @__PURE__ */ jsx6(
            "input",
            {
              ref: inputRef,
              type: "text",
              placeholder: "Paste a link",
              className: "novel-flex-1 novel-bg-white novel-p-1 novel-text-sm novel-outline-none",
              defaultValue: editor.getAttributes("link").href || ""
            }
          ),
          editor.getAttributes("link").href ? /* @__PURE__ */ jsx6(
            "button",
            {
              type: "button",
              className: "novel-flex novel-items-center novel-rounded-sm novel-p-1 novel-text-red-600 novel-transition-all hover:novel-bg-red-100 dark:hover:novel-bg-red-800",
              onClick: () => {
                editor.chain().focus().unsetLink().run();
                setIsOpen(false);
              },
              children: /* @__PURE__ */ jsx6(Trash, { className: "novel-h-4 novel-w-4" })
            }
          ) : /* @__PURE__ */ jsx6("button", { className: "novel-flex novel-items-center novel-rounded-sm novel-p-1 novel-text-stone-600 novel-transition-all hover:novel-bg-stone-100", children: /* @__PURE__ */ jsx6(Check3, { className: "novel-h-4 novel-w-4" }) })
        ]
      }
    )
  ] });
};

// src/ui/editor/bubble-menu/index.tsx
import { jsx as jsx7, jsxs as jsxs7 } from "react/jsx-runtime";
var EditorBubbleMenu = (props) => {
  const items = [
    {
      name: "bold",
      isActive: () => props.editor.isActive("bold"),
      command: () => props.editor.chain().focus().toggleBold().run(),
      icon: BoldIcon
    },
    {
      name: "italic",
      isActive: () => props.editor.isActive("italic"),
      command: () => props.editor.chain().focus().toggleItalic().run(),
      icon: ItalicIcon
    },
    {
      name: "underline",
      isActive: () => props.editor.isActive("underline"),
      command: () => props.editor.chain().focus().toggleUnderline().run(),
      icon: UnderlineIcon
    },
    {
      name: "strike",
      isActive: () => props.editor.isActive("strike"),
      command: () => props.editor.chain().focus().toggleStrike().run(),
      icon: StrikethroughIcon
    },
    {
      name: "code",
      isActive: () => props.editor.isActive("code"),
      command: () => props.editor.chain().focus().toggleCode().run(),
      icon: CodeIcon
    }
  ];
  const bubbleMenuProps = __spreadProps(__spreadValues({}, props), {
    shouldShow: ({ state, editor }) => {
      const { selection } = state;
      const { empty } = selection;
      if (editor.isActive("image") || empty || isNodeSelection(selection)) {
        return false;
      }
      return true;
    },
    tippyOptions: {
      moveTransition: "transform 0.15s ease-out",
      onHidden: () => {
        setIsNodeSelectorOpen(false);
        setIsColorSelectorOpen(false);
        setIsLinkSelectorOpen(false);
      }
    }
  });
  const [isNodeSelectorOpen, setIsNodeSelectorOpen] = useState3(false);
  const [isColorSelectorOpen, setIsColorSelectorOpen] = useState3(false);
  const [isLinkSelectorOpen, setIsLinkSelectorOpen] = useState3(false);
  return /* @__PURE__ */ jsxs7(
    BubbleMenu,
    __spreadProps(__spreadValues({}, bubbleMenuProps), {
      className: "novel-flex novel-w-fit novel-divide-x novel-divide-stone-200 novel-rounded novel-border novel-border-stone-200 novel-bg-white novel-shadow-xl",
      children: [
        /* @__PURE__ */ jsx7(
          NodeSelector,
          {
            editor: props.editor,
            isOpen: isNodeSelectorOpen,
            setIsOpen: () => {
              setIsNodeSelectorOpen(!isNodeSelectorOpen);
              setIsColorSelectorOpen(false);
              setIsLinkSelectorOpen(false);
            }
          }
        ),
        /* @__PURE__ */ jsx7(
          LinkSelector,
          {
            editor: props.editor,
            isOpen: isLinkSelectorOpen,
            setIsOpen: () => {
              setIsLinkSelectorOpen(!isLinkSelectorOpen);
              setIsColorSelectorOpen(false);
              setIsNodeSelectorOpen(false);
            }
          }
        ),
        /* @__PURE__ */ jsx7("div", { className: "novel-flex", children: items.map((item, index) => /* @__PURE__ */ jsx7(
          "button",
          {
            onClick: item.command,
            className: "novel-p-2 novel-text-stone-600 hover:novel-bg-stone-100 active:novel-bg-stone-200",
            type: "button",
            children: /* @__PURE__ */ jsx7(
              item.icon,
              {
                className: cn("novel-h-4 novel-w-4", {
                  "novel-text-blue-500": item.isActive()
                })
              }
            )
          },
          index
        )) }),
        /* @__PURE__ */ jsx7(
          ColorSelector,
          {
            editor: props.editor,
            isOpen: isColorSelectorOpen,
            setIsOpen: () => {
              setIsColorSelectorOpen(!isColorSelectorOpen);
              setIsNodeSelectorOpen(false);
              setIsLinkSelectorOpen(false);
            }
          }
        )
      ]
    })
  );
};

// src/ui/editor/extensions/image-resizer.tsx
import Moveable from "react-moveable";
import { Fragment, jsx as jsx8 } from "react/jsx-runtime";
var ImageResizer = ({ editor }) => {
  const updateMediaSize = () => {
    const imageInfo = document.querySelector(
      ".ProseMirror-selectednode"
    );
    if (imageInfo) {
      const selection = editor.state.selection;
      editor.commands.setImage({
        src: imageInfo.src,
        width: Number(imageInfo.style.width.replace("px", "")),
        height: Number(imageInfo.style.height.replace("px", ""))
      });
      editor.commands.setNodeSelection(selection.from);
    }
  };
  return /* @__PURE__ */ jsx8(Fragment, { children: /* @__PURE__ */ jsx8(
    Moveable,
    {
      target: document.querySelector(".ProseMirror-selectednode"),
      container: null,
      origin: false,
      edge: false,
      throttleDrag: 0,
      keepRatio: true,
      resizable: true,
      throttleResize: 0,
      onResize: ({
        target,
        width,
        height,
        // dist,
        delta
      }) => {
        delta[0] && (target.style.width = `${width}px`);
        delta[1] && (target.style.height = `${height}px`);
      },
      onResizeEnd: () => {
        updateMediaSize();
      },
      scalable: true,
      throttleScale: 0,
      renderDirections: ["w", "e"],
      onScale: ({
        target,
        // scale,
        // dist,
        // delta,
        transform
      }) => {
        target.style.transform = transform;
      }
    }
  ) });
};

// src/ui/editor/index.tsx
import { useEditor, EditorContent } from "@tiptap/react";
import { jsx as jsx9, jsxs as jsxs8 } from "react/jsx-runtime";
function Editor2({
  completionApi = "/api/generate",
  editorTitle = "",
  isReorderEnabled = false,
  editorTimeRange = "",
  className = "novel-relative novel-w-full h-full min-w-full novel-max-w-screen-lg novel-border-stone-200 novel-bg-white sm:novel-mb-0 sm:novel-rounded-lg sm:novel-border sm:novel-shadow-lg",
  defaultValue = "",
  extensions = [],
  editorProps = {},
  onUpdate = () => {
  },
  onDebouncedUpdate = () => {
  },
  debounceDuration = 750,
  storageKey = "novel__content",
  disableLocalStorage = false
}) {
  const [content, setContent] = use_local_storage_default(storageKey, defaultValue);
  const [hydrated, setHydrated] = useState4(false);
  const debouncedUpdates = useDebouncedCallback((_0) => __async(this, [_0], function* ({ editor: editor2 }) {
    const json = editor2.getJSON();
    onDebouncedUpdate(editor2);
    if (!disableLocalStorage) {
      setContent(json);
    }
  }), debounceDuration);
  const editor = useEditor({
    extensions: [...getDefaultExtensions(isReorderEnabled), ...extensions],
    editorProps: __spreadValues(__spreadValues({}, defaultEditorProps), editorProps),
    onUpdate: (e) => {
      const selection = e.editor.state.selection;
      const lastTwo = getPrevText(e.editor, {
        chars: 2
      });
      if (lastTwo === "++" && !isContinueWritingLoading) {
        e.editor.commands.deleteRange({
          from: selection.from - 2,
          to: selection.from
        });
        completeContinueWriting(
          getPrevText(e.editor, {
            chars: 5e3
          })
        );
      } else if (lastTwo === "--" && !isBreakItDownLoading) {
        e.editor.commands.deleteRange({
          from: selection.from - 2,
          to: selection.from
        });
        let aiGoal = editorTitle;
        if (!aiGoal && editor) {
          aiGoal = editor.state.doc.textBetween(editor == null ? void 0 : editor.state.selection.from, editor == null ? void 0 : editor.state.selection.to);
        }
        completeBreakItDown(`Goal: ${aiGoal}. Time Range: ${editorTimeRange}.
`);
      } else {
        onUpdate(e.editor);
        debouncedUpdates(e);
      }
    },
    autofocus: "end"
  });
  const { complete: completeContinueWriting, completion: completionOfContinueWriting, isLoading: isContinueWritingLoading, stop: stopContinueWriting } = useCompletion2({
    id: "continue",
    api: completionApi,
    onFinish: (_prompt, completion) => {
      editor == null ? void 0 : editor.commands.setTextSelection({
        from: editor.state.selection.from - completion.length,
        to: editor.state.selection.from
      });
    },
    onError: (err) => {
      toast3.error(err.message);
      if (err.message === "You have reached your request limit for the day.") {
      }
    }
  });
  const { complete: completeBreakItDown, completion: completionOfBreakItDown, isLoading: isBreakItDownLoading, stop: stopBreakItDown } = useCompletion2({
    id: "break",
    api: "/api/break",
    onFinish: (_prompt, completion) => {
      editor == null ? void 0 : editor.commands.setTextSelection({
        from: editor.state.selection.from - completion.length,
        to: editor.state.selection.from
      });
    },
    onError: (err) => {
      toast3.error(err.message);
      if (err.message === "You have reached your request limit for the day.") {
      }
    }
  });
  const prev1 = useRef3("");
  useEffect4(() => {
    const diff = completionOfContinueWriting.slice(prev1.current.length);
    prev1.current = completionOfContinueWriting;
    editor == null ? void 0 : editor.commands.insertContent(diff);
  }, [isContinueWritingLoading, editor, completionOfContinueWriting]);
  useEffect4(() => {
    const onKeyDown = (e) => {
      if (e.key === "Escape" || e.metaKey && e.key === "z") {
        if (isContinueWritingLoading) {
          stopContinueWriting();
          if (e.key === "Escape") {
            editor == null ? void 0 : editor.commands.deleteRange({
              from: editor.state.selection.from - completionOfContinueWriting.length,
              to: editor.state.selection.from
            });
          }
          editor == null ? void 0 : editor.commands.insertContent("++");
        }
        if (isBreakItDownLoading) {
          stopBreakItDown();
          if (e.key === "Escape") {
            editor == null ? void 0 : editor.commands.deleteRange({
              from: editor.state.selection.from - completionOfBreakItDown.length,
              to: editor.state.selection.from
            });
          }
          editor == null ? void 0 : editor.commands.insertContent("--");
        }
      }
    };
    const mousedownHandler = (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (isContinueWritingLoading) {
        stopContinueWriting();
        if (window.confirm("AI writing paused. Continue?")) {
          completeContinueWriting((editor == null ? void 0 : editor.getText()) || "");
        }
      }
      if (isBreakItDownLoading) {
        stopBreakItDown();
        if (window.confirm("AI writing paused. Continue?")) {
          let aiGoal = editorTitle;
          if (!aiGoal && editor) {
            aiGoal = editor.state.doc.textBetween(editor == null ? void 0 : editor.state.selection.from, editor == null ? void 0 : editor.state.selection.to);
          }
          completeBreakItDown(`Goal: ${aiGoal}. Time Range: ${editorTimeRange}.
`);
        }
      }
    };
    if (isContinueWritingLoading || isBreakItDownLoading) {
      document.addEventListener("keydown", onKeyDown);
      window.addEventListener("mousedown", mousedownHandler);
    } else {
      document.removeEventListener("keydown", onKeyDown);
      window.removeEventListener("mousedown", mousedownHandler);
    }
    return () => {
      document.removeEventListener("keydown", onKeyDown);
      window.removeEventListener("mousedown", mousedownHandler);
    };
  }, [
    editor,
    stopContinueWriting,
    isContinueWritingLoading,
    completeContinueWriting,
    completionOfContinueWriting.length,
    stopBreakItDown,
    isBreakItDownLoading,
    completeBreakItDown,
    completionOfBreakItDown.length
  ]);
  useEffect4(() => {
    if (!editor || hydrated)
      return;
    const value = disableLocalStorage ? defaultValue : content;
    if (value) {
      editor.commands.setContent(value);
      setHydrated(true);
    }
  }, [editor, defaultValue, content, hydrated, disableLocalStorage]);
  return /* @__PURE__ */ jsx9(
    NovelContext.Provider,
    {
      value: {
        completionApi,
        breakApi: "/api/break",
        editorTitle,
        editorTimeRange
      },
      children: /* @__PURE__ */ jsxs8(
        "div",
        {
          onClick: () => {
            editor == null ? void 0 : editor.chain().focus().run();
          },
          className,
          children: [
            editor && /* @__PURE__ */ jsx9(EditorBubbleMenu, { editor }),
            (editor == null ? void 0 : editor.isActive("image")) && /* @__PURE__ */ jsx9(ImageResizer, { editor }),
            /* @__PURE__ */ jsx9(EditorContent, { editor })
          ]
        }
      )
    }
  );
}
export {
  Editor2 as Editor
};
